import { FunctionComponent, ReactNode } from "react";

import { useParams } from "react-router-dom";

import { Permission, SecurityArea } from "../../auth/index.ts";
import { useProjectAppPermissions } from "../../hooks/index.ts";

import { RouteGuard } from "./RouteGuard.tsx";

interface Props {
    securityArea?: SecurityArea;
    hasAny?: Permission[];
    render: ReactNode;
}

export const ProjectRouteGuard: FunctionComponent<Props> = ({ securityArea, hasAny, render }) => {
    const { engagementId, projectId } = useParams();
    const appPermissions = useProjectAppPermissions(engagementId, projectId);

    if (!engagementId || !projectId) {
        throw new Error("ProjectRouteGuard: engagementId and projectId are required.");
    }

    return <RouteGuard appPermissions={appPermissions} securityArea={securityArea} hasAny={hasAny} render={render} />;
};
